import React, { useMemo } from "react";
import { useCarsCheckoutProps } from "@capone/portal";
import { useTheme } from "@material-ui/core";
import { RouteComponentProps } from "react-router-dom";
import { ExperimentState, CarsModuleProps, CoreCarsCheckout } from "redmond";
import { isCorpTenant, useUserContext } from "@capone/common";
import App from "../../../../../../cap1-modules/cars-module/src/App";

import config from "../../../utils/config";
import { colors as caponeColors } from "../../../utils/capone/colors";
import { colors as corpColors } from "../../../utils/capone-corporate/colors";

interface ICarsModuleProps extends RouteComponentProps {
  language: string;
  crossSellLoaded: boolean;
  recentlyViewedLoaded: boolean;
  annualTravelCreditLoaded: boolean;
  experiments?: ExperimentState;
  core?: CoreCarsCheckout;
}

const CarsModule = (props: ICarsModuleProps) => {
  const { language, experiments, core, ...routerProps } = props;
  const { history } = routerProps;
  const theme = useTheme();

  const { sessionInfo, policies, logo, isRewardsDisabled } = useUserContext(
    config.TENANT
  );

  const moduleProps: CarsModuleProps = useMemo(
    () => ({
      colors: isCorpTenant(config.TENANT) ? corpColors : caponeColors,
      experiments,
      language,
      theme,
      baseHistory: history,
      clientAssets: {
        sessionInfo,
        logo: <img src={logo?.src} alt={logo?.alt} />,
        policies,
        isRewardsDisabled,
      },
      isAgentPortal: config.ptIsAgentPortal,
      core,
    }),
    // The rest of the module props are intentionally captured once — the legacy
    // module reads them on mount only. `core` must stay live: the replatformed
    // funnel re-enters checkout with a different vehicle (back to shop, pick
    // another car), and a frozen `core` would leave the previous car selected,
    // so its travel wallet offer never loads for the new one.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [core, isRewardsDisabled]
  );

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <App {...moduleProps} />;
};

export const LegacyCarsBooking = (
  props: React.ComponentProps<typeof CarsModule>
) => {
  const checkoutProps = useCarsCheckoutProps();
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <CarsModule {...props} core={checkoutProps} />;
};
